var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.25C0 3.12283 0.474195 2.04183 1.31827 1.2448C2.16234 0.447767 3.30715 0 4.50084 0H12.0023C13.1959 0 14.3408 0.447767 15.1848 1.2448C16.0289 2.04183 16.5031 3.12283 16.5031 4.25V12.75C16.5031 13.8772 16.0289 14.9582 15.1848 15.7552C14.3408 16.5522 13.1959 17 12.0023 17H4.50084C3.30715 17 2.16234 16.5522 1.31827 15.7552C0.474195 14.9582 0 13.8772 0 12.75V4.25ZM21.0595 15.266L18.0034 13.2727V3.72583L21.0595 1.734C21.3408 1.55063 21.67 1.44338 22.0112 1.42385C22.3525 1.40433 22.6929 1.47327 22.9957 1.62322C23.2985 1.77318 23.5521 1.99844 23.7291 2.27464C23.9061 2.55085 23.9998 2.86749 24 3.19033V13.8082C24.0001 14.1312 23.9066 14.448 23.7297 14.7244C23.5528 15.0009 23.2992 15.2263 22.9964 15.3764C22.6936 15.5266 22.353 15.5956 22.0116 15.5762C21.6702 15.5567 21.3409 15.4494 21.0595 15.266Z",
    fill: "#F26A1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.558c7a7b95632cf69fef1a62dcb6ea36.svg";
export { ForwardRef as ReactComponent };